import { createAction } from 'redux-actions';

export const SET_COMMENTS_OPEN = 'CLIENT.COMMENTS.SET_OPEN';
export const SET_HAS_NEW_COMMENTS = 'CLIENT.COMMENTS.SET_HAS_NEW';
export const SET_OPEN_ON_LOAD = 'CLIENT.COMMENTS.SET_OPEN_ON_LOAD';

export const setCommentsOpen = createAction(SET_COMMENTS_OPEN);
export const setHasNewComments = createAction(SET_HAS_NEW_COMMENTS);
export const setOpenCommentsOnLoad = createAction(SET_OPEN_ON_LOAD);
